import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ModalComponent } from './modal/modal.component';
import { CardWithModalComponent } from './card-with-modal/card-with-modal.component';
import { ButtonComponent } from './button/button.component';
import { MaterialModule } from '../material.module';
import { CardWithImageComponent } from './card-with-image/card-with-image.component';
import { LoadingComponent } from './loading/loading.component';
import { DateOfBirthComponent } from './date-of-birth/date-of-birth.component';
import { SelectAutocompleteComponent } from './select-autocomplete/select-autocomplete.component';



@NgModule({
  declarations: [
    ModalComponent,
    CardWithModalComponent,
    ButtonComponent,
    CardWithImageComponent,
    LoadingComponent,
    DateOfBirthComponent,
    SelectAutocompleteComponent,
  ],
  imports: [
    CommonModule,
    MaterialModule,
  ],
  exports:[    
    ModalComponent,
    CardWithModalComponent,
    ButtonComponent,
    CardWithImageComponent,
    LoadingComponent,
    DateOfBirthComponent,
    SelectAutocompleteComponent,
  ]
})
export class ComponentsModule { }
